module.exports = __webpack_public_path__ + "media/img/axis/P0000-2b87d08baae25cce949916ed0ce82ca7.png";